// in src/App.js
import * as React from 'react';
import { Admin } from 'react-admin';

import dataProvider from './libs/sgx/api/dataProvider';
import authProvider from './libs/sgx/api/authProvider';
import i18nProvider from './providers/i18nProvider';


import customTheme from './layout/theme/customTheme';
import MyLayout from './layout/MyLayout';
import Dashboard from './layout/Dashboard';
import MyLoginPage from './layout/MyLoginPage';
import { customRoutes } from './layout/routes';
import resources from "./modules";



const App = () => (
    <Admin
        theme={customTheme}
        layout={MyLayout}
        loginPage={MyLoginPage}
        title="Backoffice Validador de Reglas"
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        dashboard={Dashboard}
        customRoutes={customRoutes}
        disableTelemetry >
        {permissions => resources(permissions)}
    </Admin>
);

export default App;
